// Named exports only: the recipe and the spinner are shared with IconButton
// through a direct import, never through the public barrel.
export { Button } from './button';
export type { ButtonProps } from './button';
